export default __webpack_public_path__ + "static/media/07.7b9a7ad9.jpg";